import request from '@/utils/request';
import msgData from '@/mock/message.data.js';
import { notifyServiceV1 } from '@/config/apiPrefix.config';

export const getMessages = (params) => request(`${notifyServiceV1}/announce/list`, {
    method: 'post',
    body: {
        page_num: params.pageNumber,
        page_size: params.pageSize,
        unread: params.unread,
    }
}).then(res => {
    formatMessageData(res.data_list);
    return {
        total: res.total,
        messages: res.data_list,
        unreadTotal: res.unread_total
    }
});
// export const getMessages = () => new Promise((resolve, reject) => {
//     let ret = msgData.slice();
//     resolve({
//         total: 5,
//         messages: ret
//     });
// });

export const getMessagesOnDashboard = _ => request(`${notifyServiceV1}/announce/list`, {
    method: 'post',
    body: {
        popup: true,
    }
}).then(res => {
    formatMessageData(res);
    return res;
});

// export const messageRead = (idList) => new Promise((resolve, reject) => {
//     resolve(true);
// });
export const messageRead = (idList) => request(`${notifyServiceV1}/announce/read_by_multi`, {
    method: 'post',
    body: {
        ids: idList
    }
}).then(res => {
    return {
        unreadTotal: res.unread_total,
    }
});

export const getMessageConfig = () => request(`${notifyServiceV1}/notify_config/`);

export const updateMessageConfig = (data) => request(`${notifyServiceV1}/notify_config/${data.id}`, {
    method: 'put',
    body: data
});

function formatMessageData(dataList) {
    dataList.forEach(m => {
        m.timestamp = m.timestamp ? new Date(m.timestamp.replace(/-/g, "/")) : null;
        m.indexNotif = m.indexNotif ? new Date(m.indexNotif.replace(/-/g, "/")) : null;
    });
}